import { render } from "./VDorzo.vue?vue&type=template&id=25200a46"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VDorzo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25200a46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25200a46', __exports__)) {
    api.reload('25200a46', __exports__)
  }
  
  module.hot.accept("./VDorzo.vue?vue&type=template&id=25200a46", () => {
    api.rerender('25200a46', render)
  })

}


export default __exports__